import React from 'react'
import './cta.css'

export default function Cat() {
  return (
    <div className='gpt__cat'>
      <div className='gpt__cat-content'>
      <p>Request Early Access to Get Started</p>
      <h3>Register Today & start exploring the endless possibilities.</h3>
      </div>
      <div className='gpt__cat-btn'>
        <button type='button'>
          Get Started
        </button>
      </div>
    </div>
  )
}
